<template>
    <div class="card section">
        <div class="card-body">
            <div class="row">
                <h5
                    class="col-12 d-flex align-items-center justify-content-center text-uppercase bg-light text-center py-1"
                >
                    <!-- // @NOTE single option v-select can't handle button event, therefore it's covered here -->
                    <edit-button
                        v-if="showEditButton && !multiple && value"
                        :value="value"
                        @edit="callEditOptionEvent"
                    />
                    <div
                        v-if="titleToEdit === null"
                        class="d-flex align-items-center"
                    >
                        <span>
                            {{ title }}
                        </span>
                        <div
                            class="badge edit-badge badge-secondary mx-1 pr-2"
                            @click="titleToEdit = title"
                        >
                            <i class="far fa-edit" />
                        </div>
                    </div>
                    <div v-else class="d-flex">
                        <input v-model="titleToEdit" type="text" />
                        <div
                            class="btn-sm btn-secondary pointer ml-1 pr-2"
                            @click="titleToEdit = null"
                        >
                            X
                        </div>
                        <div
                            class="badge badge-success ml-1 p-2 pointer"
                            @click="titleEdited"
                        >
                            <i class="far fa-save" />
                            Save
                        </div>
                    </div>
                </h5>

                <div
                    class="col-12"
                    :class="{
                        'better-select': showEditButton
                    }"
                >
                    <v-select
                        :value="value"
                        :label="label"
                        :multiple="multiple"
                        :options="searchResults"
                        :filterable="false"
                        @input="onInput"
                        @search="getItems"
                    >
                        <template #option="option">
                            {{ option[label] }}
                        </template>

                        <template
                            v-if="showEditButton && multiple"
                            #selected-option="option"
                        >
                            <div
                                v-b-tooltip.hover.left
                                class="option-wrapper"
                                dir="ltr"
                                :style="{ border: '0' }"
                                :title="option[label]"
                            >
                                <edit-button
                                    :value="option"
                                    @edit="callEditOptionEvent"
                                />

                                <span class="text">
                                    {{ option[label] }}
                                </span>
                            </div>
                        </template>
                    </v-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EditButton from './EditButton';

export default {
    components: {
        EditButton
    },

    props: {
        title: {
            type: String,
            required: true
        },
        value: {
            type: [Array, Object],
            required: false,
            default: null
        },
        label: {
            type: String,
            required: false,
            default: 'name'
        },
        multiple: {
            type: Boolean,
            required: false,
            default: false
        },
        getFunctionName: {
            type: String,
            required: true
        },
        showEditButton: {
            type: Boolean,
            required: false,
            default: false
        },
        filters: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            searchResults: [],
            titleToEdit: null
        };
    },

    watch: {
        getFunctionName() {
            this.getItems();
        },

        filters: {
            handler() {
                this.getItems();
            },
            deep: true
        }
    },

    mounted() {
        this.getItems();
    },

    methods: {
        async getItems(search) {
            try {
                const { rows } = await this.$store.dispatch(
                    this.getFunctionName,
                    {
                        perPage: 50,
                        page: 1,
                        ...(search && { search }),
                        filters: this.filters
                    }
                );

                this.searchResults = rows;
            } catch (err) {
                console.error(err);

                this.$toasterError();
            }
        },

        titleEdited() {
            this.$emit('title-edited', this.titleToEdit);

            this.titleToEdit = null;
        },

        onInput(val) {
            this.$emit('input', val);
        },

        callEditOptionEvent(item) {
            this.$emit('edit-option', item);
        }
    }
};
</script>
